import {
  Benefits,
  FleetManagement,
  HowItWorks,
  NextStep,
} from "@/components/FleetInquiry";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container } from "@mui/material";

const FleetInquiry = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <FleetManagement />
      <HowItWorks />
      <Benefits />
      <NextStep />
    </>
  );
};

export default FleetInquiry;
